import './ProjectParking.css';

export default function ProjectParking({ project }) {
  const { parking } = project;
  if (!parking?.show) return null;

  return (
    <section className="pd-section pd-section--alt">
      <div className={`pd-section__inner pd-parking${parking.image ? ' pd-parking--with-image' : ''}`}>
        <div className="pd-parking__text">
          <p className="pd-eyebrow">Parking</p>
          <h2 className="pd-title">{parking.heading}</h2>
          <p className="pd-parking__body">{parking.body}</p>
        </div>
        {parking.image && (
          <div className="pd-parking__media">
            <img src={parking.image} alt={`${parking.heading} — ${project.name}`} loading="lazy" />
          </div>
        )}
      </div>
    </section>
  );
}
